"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** ccadmin requires "total=true" in order to explicitly request to return Pagination in response
 *
 * @param pagination
 */
function serializeCcadminPagination(pagination) {
    return "total=true&offset=" + pagination.offset + "&limit=" + pagination.limit;
}
exports.default = serializeCcadminPagination;
